import { SCOrderListResponseType } from "@sellar-io/api-v2/types";

export const canOrderBePaid = (
  order: SCOrderListResponseType[number],
): boolean => {
  const retailerInvoice = order.Invoices.find(
    (invoice) => invoice.type === "sellarCreditRetailer",
  );

  return (
    !!order.TwoOrder?.id &&
    !order.cancelledAt &&
    !order.voidedAt &&
    !order.retailerPaidAt &&
    !!(order.dispatchedAt || order.deliveredAt) &&
    retailerInvoice?.status === "issued"
  );
};
